( function( app ) {
  const COMPONENT = {
    init: function() {
      const root = document.documentElement;
      const mobileCta = document.querySelector( '[data-mobile-navigation-cta]' );
      const navbar = document.querySelector( '[data-navigation-five-shell]' );
      const announcementBanner = document.querySelector( '#announcement-banner' );
      const adminBar = document.querySelector( '#wpadminbar' );
      const desktopMedia = window.matchMedia( '(min-width: 1024px)' );

      const updateNavigationHeights = () => {
        const mobileCtaHeight = mobileCta && !desktopMedia.matches ?
          mobileCta.getBoundingClientRect().height :
          0;
        const navbarHeight = navbar ?
          navbar.getBoundingClientRect().height :
          0;
        const announcementBannerHeight = announcementBanner && $( announcementBanner ).is( ':visible' ) ?
          announcementBanner.getBoundingClientRect().height :
          0;
        const adminBarHeight = adminBar ?
          adminBar.getBoundingClientRect().height :
          0;
        const primaryNavHeight = navbarHeight + announcementBannerHeight;
        const totalNavbarHeight = primaryNavHeight + mobileCtaHeight;
        const topOffset = totalNavbarHeight + adminBarHeight;

        root.style.setProperty( '--mobileCtaHeight', `${mobileCtaHeight}px` );
        root.style.setProperty( '--navbarHeight', `${navbarHeight}px` );
        root.style.setProperty( '--announcementBannerHeight', `${announcementBannerHeight}px` );
        root.style.setProperty( '--primaryNavHeight', `${primaryNavHeight}px` );
        root.style.setProperty( '--totalNavbarHeight', `${totalNavbarHeight}px` );
        root.style.setProperty( '--topOffset', `${topOffset}px` );
      };

      updateNavigationHeights();
      window.addEventListener( 'resize', updateNavigationHeights );
      window.addEventListener( 'navigationHeightsChanged', () => {
        window.requestAnimationFrame( updateNavigationHeights );
      } );
      desktopMedia.addEventListener( 'change', updateNavigationHeights );

      if ( 'ResizeObserver' in window ) {
        const navigationObserver = new ResizeObserver( updateNavigationHeights );
        if ( mobileCta ) navigationObserver.observe( mobileCta );
        if ( navbar ) navigationObserver.observe( navbar );
        if ( announcementBanner ) navigationObserver.observe( announcementBanner );
        if ( adminBar ) navigationObserver.observe( adminBar );
      }

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-five .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-five', COMPONENT );
} )( app );
